<template lang="pug">
  .product-recommendations(
    :is="recommendedProducts.length > 0 ? 'VueSlickCarousel' : 'div'"
    ref="productrecommendations"
    v-bind="sliderSettings"
  )
    div(v-for="product in recommendedProducts" @click="navigate(product.url, $event)")
      product-tile(
        :key="product.id"
        :product="product",
        :tile-color="tileColor"
        no-link
      )
</template>

<script>
  import axios from 'axios';
  import VueSlickCarousel from 'vue-slick-carousel';
  import ProductTile from 'scripts/components/product/ProductTile.vue';

  export default {
    name: 'ProductRecommendations',
    components: { VueSlickCarousel, ProductTile },
    props: {
      product: Object,
      tileColor: String,
    },
    data() {
      return {
        recommendedProducts: [],
        sliderSettings: {
          arrows: false,
          dots: false,
          infinite: true,
          speed: 500,
          centerMode: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: false,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        },
      };
    },
    mounted() {
      axios
        .get(`/recommendations/products?section_id=recommended-products--json&product_id=${this.product.id}&limit=8`, { withCredentials: true })
        .then((res) => {
          // get json from inside recommended-section div and parse it.
          if (res && res.data && res.data.length) {
            const temp = document.createElement('div');
            temp.innerHTML = res.data;
            const data = JSON.parse(temp.firstChild.innerText.trim());
            if (data.products instanceof Array) this.recommendedProducts = data.products;
          }
        })
        .catch((e) => console.error('error fetching recommended products', e.message));
    },
    methods: {
      navigate(link, event) {
        const centerSlide = event.currentTarget.closest('.slick-slide.slick-center');
        if (centerSlide) window.location.href = link;
        console.log(centerSlide);
      },
    },
  };
</script>

<style lang="scss">
  .product-recommendations {
    position: relative;
    margin-bottom: 40px;
    z-index: index($layout, 'page-layout-content');
    overflow: hidden;
    cursor: pointer;
  }

  .product-recommendations__wrapper {
    position: relative;
    padding: 40px 0 40px 10px;
    text-align: center;

    @include tablet-up {
      padding: 80px 0 97px 36px;
    }
  }

  .product-recommendations__title {
    color: $color-black;
    font-size: rem(32);
    text-align: center;
  }

  .product-recommendations__sub-title {
    display: block;
    color: $color-green-900;
    font-family: $font-primary;
  }
</style>
